import styled from 'styled-components';

export const SchedulerThankYouStyles = styled.div`
  background: white;
  min-height: 100vh;
  position: absolute;
  padding: 50px 0;
  overflow-y: auto;
  top: 50px;
  width: 100%;
  z-index: 2;
  
  ${props => props.theme.media.lg} {
    padding-top: 75px;
  }

  .close-btn {
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    font-size: 1rem;
    height: 1.5rem;
    width: 1.5rem;
    line-height: 1;
    position: absolute;
    top: 20px;
    right: 20px;

    ${props => props.theme.media.lg} {
      top: 100px;
      right: 50px;
    }
  }

  .text-center {
    text-align: center;
  }

  .logo {
    margin-bottom: 2rem;
    text-align: center;
  }

  .title {
    color: #5F5F5F;
    margin: 0 auto 0.2rem;
    max-width: 880px;
    font-size: 30px;
    line-height: 46px;
    font-weight: 500;
    text-align: center;
    font-family: 'Poppins';

    ${props => props.theme.media.xl} {
      font-size: 40px;
      margin-bottom: 24px;
    }
  }

  .subtitle {
    color: #5F5F5F;
    font-family: 'Poppins';
    font-size: 18px;
    line-height: 31px;
    letter-spacing: -0.09px;
    font-weight: 350;

    ${props => props.theme.media.lg} {
      font-weight: 400;
      line-height: 30px;
      width: 783px;
      margin: auto;
    }
  }

  .col-md-6 {
    padding-left: 0px;
    padding-right: 0px;
    
    ${props => props.theme.media.lg} {
      max-width: 100%;
    }
  }

  .offset-md-3 {
    ${props => props.theme.media.lg} {
      margin-left: 0%;
    }
  }

  .accountant-details {
    align-items: center;
   
    display: flex;
    justify-content: center;
    padding-bottom: 2rem;
    margin-bottom: 2rem;
    margin-top: 2rem;

    ${props => props.theme.media.lg} {
      flex-direction: column;
      margin-bottom: 0rem;
    }

    .accountant-avatar {
      border-radius: 50%;
      height: auto;
      width: 100px;

    }

    .meeting-with {
      align-items: flex-start;
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin-left: 1rem;

      .top,
      .bottom {
        color: #5F5F5F;
        font-size: 18px;
      }

      .top {
        font-weight: 500;
        line-height: 21px;

        ${props => props.theme.media.lg} {
          margin-top: 24px;
          font-size: 20px;
        }
      }
      .bottom{
        font-weight: 300;
        letter-spacing: 0px;
        
        ${props => props.theme.media.lg} {
          font-size: 20px;
        }
      }
    }
  }

  .appointment-details {
    padding: 37px 30px;
    background-color: #3F5261;
    border-radius: 15px;
    max-width: 376px;
    margin: auto;
    margin-bottom: 2rem;

    ${props => props.theme.media.lg} {
      max-width: 513px;
      justify-content: center;
    }

    .date,
    .time,
    .timezone {
      align-items: center;
      display: flex;
      justify-content: flex-start;
      margin-bottom: 1rem;
      margin-left: 1.5rem;
      text-align: center;

      ${props => props.theme.media.lg} {
        font-size: 20px;
        width: 300px;
        text-align: left;
        margin-left: 0px;
      }

      h3 {
        font-family: Poppins;
        color: #FFFFFF;
        font-weight: 400;
        margin: 0;
        font-size: 18px;
        line-height: 31px;

        ${props => props.theme.media.lg} {
          font-size: 20px;
        }
      }

      .svg-container  div {
        margin-right: 1rem;
      }
      svg {
        height: 2.3rem;
        width: auto;
        min-width: 32px;
    
        path {
          fill: #fff;
          stroke: none;
        }
      }
    }

    .date {
      h3 {
        font-size: 16px;
        letter-spacing: 0px;
        ${props => props.theme.media.lg} {
          font-size: 20px;
        }
      }
      svg {
        width: 27px;
      }
    }

    .time {
      svg {
        width: 24px;
        height: 24px;
      }
    }

    .timezone {
      margin-bottom: 0;

      svg{
        width: 24px;
        height: 24px;
      }
    }

    .

    .col-md-8 {
      padding: 0px;
      ${props => props.theme.media.lg} {
        padding-left: 1rem;
        margin-left: 0px;
      }
    }
  }

  .offset-md-2 {
    ${props => props.theme.media.lg} {
      margin-left: 0px;
    }
  }


`;
